import { render } from "./App.vue?vue&type=template&id=2bc76eb5&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2bc76eb5&scoped=true&lang=css"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc76eb5"]])

export default __exports__